import React, {useState, useEffect} from "react";
import FlightDetailsComponent from "./FlightDetailsComponent";
import FlightsShowComponent from "./FlightsShowComponent";
import {ApiCall} from "../../../helper/axios";
import {getMinutesDifference, getUserId, setCookie} from "../../../helper/commonFunction";
import FareViewsComponent, { getEffectiveTotalPriceFn } from "./FareViewsComponent";
import {getUserToken} from "../../../helper/commonFunction";
import { useDispatch } from "react-redux";
import { setndcData } from "../../../redux/slice/userSlice";

export const ListFlightItemComponent = ({
                                            index,
                                            flights,
                                            queryParams,
                                            agentActiveCurrency,
                                            headerAirportDataCityAndCountry,
                                            flightBookingFn,
                                            selectedMultiflights,
                                            roundTripDomestic,
                                            selectMultiFlightFn,
                                            showVendorLogo,
                                            seatShow,
                                            selectedAirArabiaBundle, onSelectAirArabiaBundle, displayPrice, totalMarkupAmount,
                                            isShowFlightAlternateOption,
                                            isPrintSelectionMode, isSelectedForPrint, onTogglePrintSelection
                                        }) => {
    const [openDetailsViews, setOpenDetailsViews] = useState(false);
    const [openFareViews, setOpenFareViews] = useState(false);
    const [openBundle,setopenBundle]=useState(false)
    const [fareDetails, setFairDetails] = useState({});
    const userToken = getUserToken();
    const [lowPrice,setlowestPricing]=useState(0)
    const dispatch = useDispatch()
    const storeNdcOriginalDataFn = (originalData) => {
        if (!originalData) return;

        let storedBlocks = [];
        try {
            const raw = sessionStorage.getItem('ndcData');
            storedBlocks = raw ? JSON.parse(raw) : [];
        } catch (error) {
            storedBlocks = [];
        }
        if (!Array.isArray(storedBlocks)) storedBlocks = [];

        const offerIdsOfFn = (block) => (block?.selectedOfferOptions || [])
            .map((offer) => offer?.offerId)
            .filter(Boolean);

        const incomingOfferIds = offerIdsOfFn(originalData);
        const alreadyStored = incomingOfferIds.length > 0 && storedBlocks.some((block) => {
            const storedOfferIds = offerIdsOfFn(block);
            return incomingOfferIds.every((offerId) => storedOfferIds.includes(offerId));
        });
        if (alreadyStored) return;

        storedBlocks.push(originalData);
        sessionStorage.setItem('ndcData', JSON.stringify(storedBlocks));
    };

    const applyMarkupToPricing = (pricingData = [], markupAmount = 0) => {
        const markupValue = Number(markupAmount);
        if (!Array.isArray(pricingData) || !Number.isFinite(markupValue) || markupValue <= 0) {
            return pricingData;
        }

        return pricingData.map((pricingItem) => {
            const currentTotalPrice = Number(pricingItem?.totalPrice);
            if (!Number.isFinite(currentTotalPrice)) {
                return pricingItem;
            }

            return {
                ...pricingItem,
                totalPrice: currentTotalPrice + markupValue,
            };
        });
    };

    const applyMarkupToAirArabiaData = (airArabiaData, markupAmount = 0) => {
        const markupValue = Number(markupAmount);
        if (!Number.isFinite(markupValue) || markupValue <= 0 || !airArabiaData) {
            return airArabiaData;
        }

        // API can return either an array of bundles or an object with bundleService.
        if (Array.isArray(airArabiaData)) {
            return airArabiaData.map((bundle) => {
                const currentPrice = Number(bundle?.price);
                if (!Number.isFinite(currentPrice)) {
                    return bundle;
                }

                return {
                    ...bundle,
                    price: currentPrice + markupValue,
                };
            });
        }

        return {
            ...airArabiaData,
            bundleService: Array.isArray(airArabiaData?.bundleService)
                ? airArabiaData.bundleService.map((bundle) => {
                    const currentPrice = Number(bundle?.price);
                    if (!Number.isFinite(currentPrice)) {
                        return bundle;
                    }

                    return {
                        ...bundle,
                        price: currentPrice + markupValue,
                    };
                })
                : airArabiaData?.bundleService,
        };
    };

    useEffect(() => {
        if (flights?.flightDHTRId) {
            setOpenDetailsViews(false);
            setOpenFareViews(false);
            setFairDetails(prevState => ({
                ...prevState,
                ...flights,
                amaduesFaresData: null,
                tripJackFareRuleData: null,
                tripJackFareActiveIndex: null,
                fareRuleCancellationAmount: null,
                ndcFaresData: null,
                travelFusionLoadData : false
            }));
        }
    }, [flights]);

    const loadAlternateFlightFareData = async (flightData) => {
        if (!flightData?.source) return null;

        if (flightData?.source === "amadeus") {
            let queryPayload = {
                tripType: flightData?.source,
                flightDetails: {
                    sid: flightData?.sessionId,
                    flightOption: [{
                        Type: flightData?.sessionType,
                        Id: flightData?.flightIndexID
                    }]
                },
                flightDHTRId: flightData?.flightDHTRId,
                activeCurrency: "AED",
            };
            let amaduesViewFares = await ApiCall('POST', '/flights/get-flight-details', queryPayload, {authorization: userToken});
            if (amaduesViewFares?.status === 200 && amaduesViewFares?.data?.statusCode === 200) {
                return {
                    amaduesFaresData: {
                        ...amaduesViewFares?.data?.data,
                        pricing: applyMarkupToPricing(amaduesViewFares?.data?.data?.pricing, totalMarkupAmount),
                    },
                };
            }
            return {};
        }

        if (flightData?.source === "air-arabia") {
            let queryPayload = {
                tripType: flightData?.source,
                activeCurrency: "AED",
                flightSegment: flightData?.segments,
                passenger: flightData?.pricing?.[0]?.passengers,
                directionType: flightData?.tripType
            };
            let airArabiaViewFares = await ApiCall('POST', '/flights/get-flight-details', queryPayload, {authorization: userToken});
            if (airArabiaViewFares?.status === 200 && airArabiaViewFares?.data?.statusCode === 200 && !airArabiaViewFares?.data?.data?.data?.error) {
                return {
                    airArabiaFlightData: applyMarkupToAirArabiaData(airArabiaViewFares?.data?.data?.data, totalMarkupAmount),
                    airArabiaFlightLastCall: new Date(),
                };
            }
            return {};
        }

        if (flightData?.source === "ndc-portal") {
            let searchQuery = {
                ...(parseInt(queryParams?.adult) ? {ADT: parseInt(queryParams?.adult)} : {}),
                ...(parseInt(queryParams?.child) ? {CHD: parseInt(queryParams?.child)} : {}),
                ...(parseInt(queryParams?.infant) ? {INF: parseInt(queryParams?.infant)} : {}),
            };
            let payload = {
                OfferId: flightData?.routingId,
                tripType: flightData?.source,
                haveBundles: flightData?.haveBundles,
                flightDHTRId: flightData?.flightDHTRId,
                count: queryParams?.returnDate ? 2 : 1,
                searchQuery,
            };
            let ndcViewFares = await ApiCall('POST', '/flights/get-flight-details', payload, {authorization: userToken});
            if (ndcViewFares?.status === 200 && ndcViewFares?.data?.statusCode === 200) {
                storeNdcOriginalDataFn(ndcViewFares?.data?.data?.originalData);
                return {
                    ndcFaresData: {
                        pricing: applyMarkupToPricing(ndcViewFares?.data?.data?.pricing, totalMarkupAmount),
                    },
                };
            }
            return {};
        }

        return {};
    };

    const setViewFaresDataFn = async (flightData, index) => {
        if (flightData?.source === "amadeus" && !fareDetails?.amaduesFaresData) {
            setFairDetails(prevState => ({
                ...prevState,
                amaduesLoader: true,
            }));
            let queryPayload = {
                tripType: flightData?.source,
                flightDetails: {
                    sid: flightData?.sessionId,
                    flightOption: [{
                        Type: flightData?.sessionType,
                        Id: flightData?.flightIndexID
                    }]
                },
                flightDHTRId : flightData?.flightDHTRId,
                activeCurrency: "AED",
            };
            let amaduesViewFares = await ApiCall('POST', '/flights/get-flight-details', queryPayload, {authorization: userToken});
            if (amaduesViewFares?.status === 200 && amaduesViewFares?.data?.statusCode === 200) {
                setFairDetails(prevState => ({
                    ...prevState,
                    amaduesLoader: false,
                    amaduesFaresData: {
                        ...amaduesViewFares?.data?.data,
                        pricing: applyMarkupToPricing(amaduesViewFares?.data?.data?.pricing, totalMarkupAmount),
                    },
                }));
            }else{
                setFairDetails(prevState => ({
                    ...prevState,
                    amaduesLoader: false,
                }));
            }
        } else if (flightData?.source === "tripjack" && !fareDetails?.tripJackFareRuleData) {
            setFairDetails(prevState => ({
                ...prevState,
                tripJackLoader: true,
            }));
            let queryPayload = {
                source: flightData?.source,
                priceId: flightData?.pricing?.[0]?.id,
                type: "SEARCH",
                activeCurrency: agentActiveCurrency,
                flightDHTRId : flightData?.flightDHTRId
            };
            let tripJackFareRules = await ApiCall('POST', '/flights/fare-rules', queryPayload, {authorization: userToken});
            if (tripJackFareRules?.status === 200 && tripJackFareRules?.data?.statusCode === 200) {
                let flightAirportData = `${flightData?.segments[0]?.departure?.airportCode}-${flightData?.segments[flightData?.segments?.length - 1]?.arrival?.airportCode}`;
                let fareRuleCancellationAmount = tripJackFareRules?.data?.data?.data?.fareRule?.[flightAirportData]?.fr?.['CANCELLATION']?.['BEFORE_DEPARTURE']?.amount;
                setFairDetails(prevState => ({
                    ...prevState,
                    tripJackLoader: false,
                    tripJackFareRuleData: tripJackFareRules?.data?.data?.data?.fareRule,
                    tripJackFareActiveIndex: tripJackFareRules?.data?.data?.data?.fareRule && Object?.keys(tripJackFareRules?.data?.data?.data?.fareRule)?.length ? Object.keys(tripJackFareRules?.data?.data?.data?.fareRule)?.[0] : '',
                    fareRuleCancellationAmount: fareRuleCancellationAmount,
                }));
            } else {
                setFairDetails(prevState => ({
                    ...prevState,
                    tripJackLoader: false,
                }));
            }
        } else if (flightData?.source === "travel-fusion") {
            /*if(!fareDetails?.travelFusionLoadData){
                setFairDetails({...flights, tarvelFusionLoader: true,});
                let queryPayload = {
                    tripType: flightData?.source,
                    routingId: flightData?.routingId,
                    outwardId: flightData?.pricing?.map(price => price?.id),
                    activeCurrency: agentActiveCurrency,
                }
                let travelFusionViewFares = await ApiCall('POST', '/flights/get-flight-details', queryPayload,{authorization: userToken});
                if (travelFusionViewFares?.status === 200 && travelFusionViewFares?.data?.statusCode === 200 && !travelFusionViewFares?.data?.data?.data?.error) {
                    let travelFusionLoadData = travelFusionViewFares?.data?.data;
                    let newFlightData = { ...flights };
                    if (newFlightData?.pricing?.length) {
                        newFlightData.pricing = newFlightData.pricing.map((priceData) => {
                            const tId = priceData?.id;
                            const passengerData = priceData?.passengers;
                            let newSetPassData = {};
                            const findData = travelFusionLoadData?.find(tData => tData?.outwardId === tId);
                            if (findData) {
                                Object.keys(passengerData || {}).forEach((pass) => {
                                    const newPassData = findData?.pricing;
                                    const passengerDetails = passengerData?.[pass];
                                    const findType = newPassData.find(pas => pas?.passengerType === pass);
                                    if (findType) {
                                        newSetPassData[pass] = {
                                            ...passengerDetails,
                                            baggageInfo: findType?.baggageInfo ?? {}
                                        };
                                    }
                                });
                            }
                            return {
                                ...priceData,
                                passengers: newSetPassData
                            };
                        });
                    }
                    newFlightData.travelFusionLoadData = true;
                    newFlightData.tarvelFusionLoader = false;
                    setFairDetails(newFlightData)
                } else {
                    setFairDetails({...flights, tarvelFusionLoader: false});
                }
            }*/
        } else if (flightData?.source === "air-arabia") {
            let callApi = true;
            if (fareDetails?.airArabiaFlightLastCall) {
                let diffMinute = getMinutesDifference(fareDetails?.airArabiaFlightLastCall);
                if (14 > diffMinute) {
                    callApi = false;
                }
            }
            if (callApi) {
                setFairDetails({...flights, airArabiaLoader: true,});
                let queryPayload = {
                    tripType: flightData?.source,
                    activeCurrency: "AED",
                    flightSegment: flightData?.segments,
                    passenger: flightData?.pricing?.[0]?.passengers,
                    directionType: flightData?.tripType
                }
                let airArabiaViewFares = await ApiCall('POST', '/flights/get-flight-details', queryPayload,{authorization: userToken});
                if (airArabiaViewFares?.status === 200 && airArabiaViewFares?.data?.statusCode === 200 && !airArabiaViewFares?.data?.data?.data?.error) {
                    setFairDetails({
                        ...flights,
                        airArabiaLoader: false,
                        airArabiaFlightData: applyMarkupToAirArabiaData(airArabiaViewFares?.data?.data?.data, totalMarkupAmount),
                        airArabiaFlightLastCall: new Date(),
                    });
                } else {
                    setFairDetails({...flights, airArabiaLoader: false});
                }
            }
        } else if (flightData?.source === "akasa-air") {
            // setFairDetails({...flights, akasaAirLoader: true,});
        }
        else if(flightData?.source === 'ndc-portal' && !fareDetails?.ndcFaresData){
            if(flightData){
                let searchQuery = {}
                searchQuery = {
                    ...(parseInt(queryParams?.adult) ? {ADT: parseInt(queryParams?.adult)} : {}),
                    ...(parseInt(queryParams?.child) ? {CHD: parseInt(queryParams?.child)} : {}),
                    ...(parseInt(queryParams?.infant) ? {INF: parseInt(queryParams?.infant)} : {}),
                }
                let payload = {
                    OfferId : flightData?.routingId,
                    tripType : flightData?.source,
                    haveBundles : flightData?.haveBundles,
                    flightDHTRId : flightData?.flightDHTRId,
                    count : queryParams?.returnDate ? 2 : 1,
                    searchQuery,
                }
                setFairDetails(prevState => ({
                    ...prevState,
                    ndcLoader: true,
                }));
                setCookie('ndcOfferId', JSON.stringify(payload?.OfferId));
                let ndcViewFares = await ApiCall('POST', '/flights/get-flight-details', payload, {authorization: userToken});
                if (ndcViewFares?.status === 200 && ndcViewFares?.data?.statusCode === 200) {
                    setFairDetails(prevState => ({
                        ...prevState,
                        ndcLoader: false,
                        ndcFaresData: {
                            pricing: applyMarkupToPricing(ndcViewFares?.data?.data?.pricing, totalMarkupAmount),
                        },
                    }));

                    let lowest = Math.min(...ndcViewFares?.data?.data?.pricing?.map(f => getEffectiveTotalPriceFn(f) || Infinity))
                    if (lowest !== Infinity) {
                        setlowestPricing(lowest);
                    }

                    sessionStorage.removeItem('ndcDataBundle')
                    storeNdcOriginalDataFn(ndcViewFares?.data?.data?.originalData)
                    dispatch(setndcData(ndcViewFares?.data?.data?.originalData))
                } else {
                    setFairDetails(prevState => ({
                        ...prevState,
                        ndcLoader: false,
                    }));
                }
            }
        }
    };
    return (
        <li
            data-key={index}
            data-print-selected={isSelectedForPrint ? "true" : "false"}
            key={index}
            className="hw-search--flightFilterResult__listItem"
        >
            {isPrintSelectionMode ? (
                <div className="hw-print-selection-box d-flex align-items-center hw-gapy10 mb-2" style={{justifyContent:"end"}}>
                    <input
                        style={{cursor : "pointer"}}
                        type="checkbox"
                        aria-label={`Select flight ${index + 1} for print`}
                        checked={!!isSelectedForPrint}
                        onChange={onTogglePrintSelection}
                    />
                </div>
            ) : null}
            {flights?.source === 'verteil' ?
                <div className="mb-2">
                    <button className="hw-ndc-fare">NDC Fare</button>
                </div>
            : ''}
            <FlightsShowComponent
                flights={flights}
                flightTabChangeFn={(_, type) => {
                    if (type === "openFareViews") {
                        setOpenFareViews(!openFareViews);
                        return;
                    }

                    if (type === "openFlightDetails") {
                        setOpenDetailsViews(!openDetailsViews);
                        return;
                    }
                }}
                setViewFaresDataFn={() => {setViewFaresDataFn(flights)}}
                agentActiveCurrency={agentActiveCurrency}
                index={index}
                queryParams={queryParams}
                openFareViews={openFareViews}
                openDetailsViews={openDetailsViews}
                showVendorLogo={showVendorLogo}
                seatShow={seatShow}
                lowPrice={lowPrice}
                displayPrice={displayPrice}
            />
            {openDetailsViews ? (
                <FlightDetailsComponent
                    flights={{...flights, ...fareDetails}}
                    flightTabChangeFn={() => {
                        setOpenDetailsViews(!openDetailsViews);
                    }}
                    headerAirportDataCityAndCountry={headerAirportDataCityAndCountry}
                    queryParams={queryParams}
                    agentActiveCurrency={agentActiveCurrency}
                    index={index}
                    setFlightData={(overrideData) => {
                        setFairDetails({
                            ...fareDetails,
                            ...overrideData,
                        });
                    }}
                    openFareViews={openFareViews}
                    displayPrice={displayPrice}
                />
            ) : (
                ""
            )}
            {openFareViews ? (
                <FareViewsComponent
                    flights={{...flights, ...fareDetails}}
                    flightBookingFn={flightBookingFn}
                    agentActiveCurrency={agentActiveCurrency}
                    selectedMultiflights={selectedMultiflights}
                    roundTripDomestic={roundTripDomestic}
                    selectMultiFlightFn={selectMultiFlightFn}
                    openFareViews={openFareViews}
                    setOpenFareViews={setOpenFareViews}
                    queryParams={queryParams}
                    selectedAirArabiaBundle={selectedAirArabiaBundle}
                    onSelectAirArabiaBundle={onSelectAirArabiaBundle}
                    showBundles={openBundle}
                    setBundle={setopenBundle}
                    displayPrice={displayPrice}
                    totalMarkupAmount={totalMarkupAmount}
                    loadAlternateFlightFareData={loadAlternateFlightFareData}
                    showVendorLogo={showVendorLogo}
                    isShowFlightAlternateOption={isShowFlightAlternateOption}
                />
            ) : (
                ""
            )}
        </li>
    );
};
